import { Tag, type TagProps } from '@eluve/components';

/**
 * FHIR status codes → presentation tone. Shared across resource types:
 * Observation and DiagnosticReport status machines overlap, and the
 * unknown-code fallback keeps forward compatibility with codes we
 * haven't mapped.
 */
const STATUS_COLOR: Record<string, TagProps['color']> = {
  final: 'positive',
  completed: 'positive',
  fulfilled: 'positive',
  resolved: 'positive',
  finished: 'positive',
  active: 'lightblue',
  'in-progress': 'teal',
  amended: 'info',
  corrected: 'info',
  appended: 'info',
  booked: 'lightblue',
  arrived: 'teal',
  'checked-in': 'teal',
  preliminary: 'warning',
  registered: 'warning',
  partial: 'warning',
  proposed: 'warning',
  pending: 'warning',
  waitlist: 'warning',
  'on-hold': 'warning',
  draft: 'warning',
  intended: 'warning',
  'entered-in-error': 'negative',
  cancelled: 'negative',
  noshow: 'negative',
  stopped: 'negative',
  'not-done': 'negative',
};

function humanizeStatus(status: string): string {
  const words = status.replace(/-/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** Status pill for a FHIR resource's lifecycle status; renders nothing without one. */
export function FhirStatusTag({ status }: { status?: string }) {
  if (!status) return null;
  return (
    <Tag
      pill
      subtle
      size="xs"
      color={STATUS_COLOR[status] ?? 'gray'}
      label={humanizeStatus(status)}
    />
  );
}
